
  import Cell from '@/components/dataTables/cell/cell'
  import GAlertConfirmation from '@/components/core/alert/GAlertConfirmation.vue'
  import { Component, Prop } from 'vue-property-decorator'
  import { mapGetters } from 'vuex'

@Component({
  components: {
    GAlertConfirmation,
  },
  computed: {
    ...mapGetters('resources', ['all']),
  },
})
  export default class StockToEnablementCell extends Cell {
    // Props
    @Prop({ type: String, default: 'success' }) buttonColor!: string;
    @Prop({ type: String, default: 'fab' }) buttonType!: string;
    @Prop({ type: String, default: 'small' }) buttonSize!: string;
    @Prop({ type: String, default: 'mdi-car-wrench' }) iconButton!: string;
    @Prop({ type: String, default: 'white' }) iconButtonColor!: string;
    @Prop({ type: String, default: '' }) buttonText!: string;
    @Prop({ type: Boolean, default: false }) blockButton!: boolean;

    // Computed
    get showIcon (): boolean {
      return Boolean(this.iconButton)
    }

    vehicle = ''

    // Data
    dialog = false

    // Methods
    openDialog () {
      this.vehicle = this.item.auto.name
      this.dialog = true
    }

    closeDialog () {
      this.dialog = false
    }

    async confirmChange () {
      const status = (await this.fetchData({
        query: { name: 'find', model: 'ProcessStatus' },
        filter: { _and: [{ process: { table_name: { _eq: 'stock' } } }, { status: { name: { _eq: 'enabling' } } }] },
        force: true,
      }))[0]

      const enablementStatus = (await this.fetchData({
        query: { name: 'find', model: 'ProcessStatus' },
        filter: { _and: [{ process: { table_name: { _eq: 'enablement' } } }, { status: { name: { _eq: 'to_confirm' } } }] },
        force: true,
      }))[0]

      await this.pushData({
        model: 'Stock',
        fields: {
          id: this.item.id,
          id_process_status: status.id,
        },
      })

      this.publishStock(this.item.id)

      await this.pushData({
        model: 'Enablement',
        fields: {
          id: this.item.viewDetails.idEnablement,
          id_process_status: enablementStatus.id,
          id_closing_reason: null,
        },
      })

      this.closeDialog()
      window.location.reload()
    }

    // Getters
    get disabledButton () {
      return this.item?.status?.name !== 'available'
    }
  }
